import React, {useEffect, useState} from "react";
import PageHeader from "../../components/organisms/PageHeader";
import request from "../../config/Axios";
import List from "../../components/organisms/List";

const Special = () => {
    const [row, setRow] = useState([]);
    const navList = [
        {
            name: "강아지숲 박물관",
            link: "/program/museum"
        },
        {
            name: "상설프로그램",
            link: "/program/permanent"
        },
        {
            name: "특별프로그램",
            link: "/program/special"
        },
        {
            name: "도그 스포츠",
            link: "/program/dogsports"
        },
    ];
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);

    useEffect(() => {
        (async () => {
            try {
                const specialResponse = await request.get(`boards/special/posts`,{
                    params: {
                        page: page
                    }
                });
                setRow(specialResponse.data.data.postList);
                setTotalPages(specialResponse.data.data.totalPages);
                window.scrollTo(0, 500);
            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }
        })();
    }, [page]);
    return (
        <>
            <PageHeader
                bTitle="프로그램"
                detail="특별프로그램"
                desc="강아지숲의 특별프로그램을 안내해 드립니다."
                list={navList}
                top={true}

            />
          <List
                row={row}
                columns={3}
                category={"특별프로그램"}
                totalPages={totalPages}
                page={page}
                changePage={setPage}
            />
        </>
    );
};

export default Special;
